module.exports = __webpack_public_path__ + "media/images/mypage/icon/green-pale/ico_message-48da335e5fba0236349afce8fbeba5ec.svg";